var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAxe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "103.029%",
    y1: "15.203%",
    x2: "5.388%",
    y2: "46.634%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA461",
    offset: "10.449%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA461",
    offset: "24.407%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6D52",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.707 43.72c-41.036-10.787-83.632-19.6-83.632-19.6S41.312 32.257 0 43.458c.474-2.64 1.698-5.142 3.64-7.057L35.547 4.935C38.306 2.213 43.722 0 47.634 0h72.394c3.913 0 9.324 2.21 12.088 4.935L164.021 36.4c2.008 1.98 3.248 4.585 3.686 7.32zm-93.02 106.228L1.88 54.215A12.47 12.47 0 010 50.65c36.235-4.77 65.296-7.255 65.296-7.255 5.186-.476 9.39 3.298 9.39 8.431v98.122zm90.976-95.772L92.857 149.91V51.813c0-5.132 4.21-8.906 9.397-8.415 0 0 29.176 2.541 65.256 7.312a12.457 12.457 0 01-1.847 3.466z",
    fillRule: "nonzero",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxe);
export default __webpack_public_path__ + "static/media/axe.1da3ba0a47e0a3ae3d091f0bb40b44cb.svg";
export { ForwardRef as ReactComponent };